import {addInventoryToCart, getInventory} from "../../api/Api";
import {useEffect, useRef, useState} from 'react';
import {Button, Checkbox, Table, message, Row, Col} from "antd";
import {CategoryType, ProductType, ProductSubType, UnitType} from "../../api/Constants";
import {AddCartWidget} from "./AddCartWidget";
import {getColumnSearchProps} from "../widget/SearchProps";
import {toUtcDateStringShort} from "../../util/timeutils";
import {Link} from "react-router";
import {BookStatusTag} from "./BookStatusTag";
import {fixedToDisplayUnit, displayToFixedUnit} from "../../util/unitutils";

export const InventoryTable = ({onApiFail, addToCart, refresh, lowInventoryAlert=false, disableLinks=false, props}) => {
    const [inventory, setInventoryList] = useState([]);
    const [messageApi, contextHolder] = message.useMessage()
    const [showHidden, setShowHidden] = useState(false);

    useEffect(() => {
        getInventory(showHidden).then((x) => {
            let tableData = x.map((val, index) => {
                return {...val, key: index}
            });
            if (lowInventoryAlert === true) {
                console.log(`filtering`);
                tableData = tableData.filter(row => ((row.enableAlert===1) && (row.quantity <= row.alertQuantity )));
            }
            setInventoryList(tableData);
        }).catch (e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
        });
    }, [refresh, onApiFail, lowInventoryAlert, showHidden]);

    // const adjustQuantity = (itemRecord) => (value, mode) => {
    //     console.log(`item ${itemRecord.id} mode ${mode}, value ${value}`);
    //     const isSet = mode === InventoryAdjustmentType.Set;
    //
    //     updateInventory(itemRecord.id, value, isSet).then(x => {
    //         console.log(`item ${itemRecord.id} quantity ${value} updated successfully`);
    //         setRefresh2(refresh2+1);
    //     }).catch(e => {
    //         if ((e.status === 401) && (onApiFail)) {
    //             onApiFail();
    //         }
    //     })
    // }

    const addCart = (itemRecord) => (value) => {
        console.log(`adding ${value} of item ${itemRecord.id} to cart`);
        const fixedQuantity = displayToFixedUnit(value, itemRecord.unit);
        addInventoryToCart(itemRecord.id, fixedQuantity).then(r => {
            if (addToCart) {
                addToCart(itemRecord, fixedQuantity)
            }
            messageApi.open({
                type: 'success',
                content: `${itemRecord.name} added to cart`
            });
        }).catch(e => {
            if ((e.status === 401) && (onApiFail)) {
                onApiFail();
            }
            messageApi.open({
                type: 'error',
                content: `Failed to add ${itemRecord.name} to cart`
            });
        })
    }

    const onShowHidden = (e) => {
        setShowHidden(e.target.checked);
    }

    const searchInput = useRef(null);

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (val, record, index) => {
                // disable links for certain views,  it becomes a click hazard and loses the page context
                if (disableLinks === true) {
                    return val;
                }
                return <Link to={`/inventory/${record.id}`}>{val}</Link>
            },
            sorter: (a, b) => a.name.toLowerCase().localeCompare(b.name.toLowerCase()),
            ...getColumnSearchProps('name', searchInput)
        },
        {
            title: 'Sku',
            dataIndex: 'sku',
            key: 'sku'
        },
        {
            title: 'Description',
            dataIndex: 'description',
            key: 'description',
        },
        {
            title: 'Quantity',
            dataIndex: 'quantity',
            key: 'quantity',
            render: (val, record, index) => {
                const displayQuantity = fixedToDisplayUnit(val, record.unit);
                if (record.category === CategoryType.Wholesale) {
                    return `${displayQuantity} ${UnitType.Label[record.unit]}
                    `
                }
                return displayQuantity;
            },
            sorter: (a, b) => a.quantity - b.quantity
        },
        {
            title: 'Category',
            dataIndex: 'category',
            key: 'category',
            render: (val, record, index) => {
                switch (val) {
                    default:
                    case CategoryType.Wholesale:
                        return "Bulk/Wholesale"
                    case CategoryType.Packaged:
                        return "Packaged";
                    case CategoryType.Supplies:
                        return "Supplies";
                }
            },
            sorter: (a, b) => a.category - b.category
        },
        {
            title: 'Type',
            dataIndex: 'type',
            key: 'type',
            render: (val, record, index) => {
                return ProductType.Label[val];
            },
            sorter: (a, b) => a.type.toLowerCase().localeCompare(b.type.toLowerCase()),
        },
        {
            title: 'Sub Type',
            dataIndex: 'subtype',
            key: 'subtype',
            render: (val, record, index) => {
                return ProductSubType.Label[val];
            },
            sorter: (a, b) => a.subtype.toLowerCase().localeCompare(b.subtype.toLowerCase()),
        },
        {
            title: 'Created',
            dataIndex: 'created',
            key: 'created',
            render: (val, record, index) => {
                return toUtcDateStringShort(new Date(val))
            },
            sorter: (a, b) => {
                const {created: aCreated} = a;
                const {created: bCreated} = b;
                return (new Date(aCreated))- (new Date(bCreated))
            },
        },
        {
            title: 'Book',
            dataIndex: 'book',
            key: 'book',
            render: (val, record, index) => {
                return <BookStatusTag book={val} />
            },
            sorter: (a, b) => a.book - b.book
        }
    ];

    if (addToCart !== undefined) {
        columns.push({
            title: '',
            dataIndex: 'id',
            key: 'id',
            render: (val, record, index) => {
                return <AddCartWidget onAdjust={addCart(record)} item={record}><Button>Add to Cart</Button></AddCartWidget>
            }
        })
    }

    const tablePagination = {
        defaultPageSize: 50,
        showSizeChanger: true,
        pageSizeOptions: [50, 100, 150, 200]
    }

    return <div>
        {contextHolder}
        <div style={{textAlign: 'right'}}>
            <Row>
                <Col style={{margin: '5px'}}>
                    <Checkbox checked={showHidden} onChange={onShowHidden} />
                </Col>
                <Col style={{margin: '5px'}}>
                    <b>Show Hidden</b>
                </Col>
            </Row>
        </div>
        <Table dataSource={inventory} columns={columns} pagination={tablePagination}/>
    </div>
}